import { CIcon } from '~/icons/types'
export const ciFuel: CIcon = {
  width: 512,
  height: 502.2,
  paths: [
    {
      d:
        'M509.3 99.8v-.3c-.1-.4-.2-.8-.3-1.3v-.1c-.1-.4-.3-.9-.5-1.3 0-.1-.1-.2-.1-.2-.2-.4-.4-.8-.6-1.1v-.1l-.1-.1-59.6-90.2c-3.2-4.8-9.7-6.2-14.5-3s-6.2 9.7-3 14.5L457.9 58v43.1c0 5.8 4.7 10.5 10.5 10.5h20v243.5c0 9.8-4.6 19.2-12.4 25.2-7.2 5.5-17.2 5.6-24.4.2l-.4-.3c-8-6-12.8-15.5-12.8-25.5V205.8c0-34.6-25.6-63.4-58.9-68.3V58.1c0-32-26.1-58.1-58.1-58.1H102.6c-32 0-58.1 26.1-58.1 58.1v353.2c-23.4 1.9-41.8 21.5-41.8 45.4 0 25.1 20.4 45.5 45.5 45.5h327.5c25.1 0 45.5-20.4 45.5-45.5 0-23.9-18.5-43.5-41.8-45.4V158.8c21.7 4.7 37.9 24 37.9 47v148.9c0 16.6 8 32.5 21.3 42.4l.4.3c7.3 5.4 15.9 8.1 24.6 8.1 8.9 0 17.8-2.8 25.1-8.5 12.9-9.9 20.7-25.6 20.7-41.9V101.2c0-.5-.1-1-.1-1.4zM400.2 456.7c0 13.5-11 24.5-24.5 24.5H48.1c-13.5 0-24.5-11-24.5-24.5s11-24.5 24.5-24.5H55c5.8 0 10.5-4.7 10.5-10.5V58.1c0-20.5 16.6-37.1 37.1-37.1h218.6c20.5 0 37.1 16.6 37.1 37.1v363.6c0 5.8 4.7 10.5 10.5 10.5h6.8c13.6 0 24.6 11 24.6 24.5z'
    },
    {
      d:
        'M299.8 61.6H124c-5.8 0-10.5 4.7-10.5 10.5v106.8c0 5.8 4.7 10.5 10.5 10.5h175.8c5.8 0 10.5-4.7 10.5-10.5V72.1c0-5.8-4.7-10.5-10.5-10.5zm-10.5 106.9H134.5V82.6h154.8v85.9z'
    }
  ],
  name: 'fuel',
  type: 'regular'
}
